/*
 * Copyright (c) 2026.
 * # Autor: TECINCO TECNOLOGIA
 * # Dev: Alejandro Meriño Rodrìguez
 * # Versión: 2.0.0
 */

import {IconType, ClassType} from '@llm/factories/ui-config.enums';

export interface Configuration {
    icon: IconType;
    nameClass: ClassType;
    references: {
        negative: string;
    };
}

export interface ConfigFactory {
    create(): Configuration;
}

export class ClientConfigFactory implements ConfigFactory {
    create(): Configuration {
        return {
            icon: IconType.PERSON,
            nameClass: ClassType.CLIENTE,
            references: { negative: 'fechar janela' }
        };
    }
}

export class OsBudgetConfigFactory implements ConfigFactory {
    create(): Configuration {
        return {
            icon: IconType.LOCAL_SHIPPING,
            nameClass: ClassType.OS_BUDGET,
            references: { negative: 'cancelar' }
        };
    }
}
